// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClearedSubmitController from "./cleared_submit_controller"
application.register("cleared-submit", ClearedSubmitController)

import DrawMapController from "./draw_map_controller"
application.register("draw-map", DrawMapController)

import FormRedirectController from "./form_redirect_controller"
application.register("form-redirect", FormRedirectController)

import PaginationControlsController from "./pagination_controls_controller"
application.register("pagination-controls", PaginationControlsController)

import PaginationSearchController from "./pagination_search_controller"
application.register("pagination-search", PaginationSearchController)

import PaginationSubmitController from "./pagination_submit_controller"
application.register("pagination-submit", PaginationSubmitController)

import RenderReactComponentController from "./render_react_component_controller"
application.register("render-react-component", RenderReactComponentController)

import SelectSubmitController from "./select_submit_controller"
application.register("select-submit", SelectSubmitController)

import SortControlsController from "./sort_controls_controller"
application.register("sort-controls", SortControlsController)

import SortSubmitController from "./sort_submit_controller"
application.register("sort-submit", SortSubmitController)
